import React from "react";

export default function SolarPanelSummary({ answers = {} }) {
  return (
    <section className="card main-card cc-solar-panel-summary" aria-label="House ownership and solar panels">
      <div className="card-body">
        <h3 className="h6">House ownership and solar panels</h3>
        <dl className="row mb-0">
          {[
            ["Home ownership", "ownsHouse"],
            ["Outstanding solar panel loan amount", "solarLoanAmount"],
            ["Do you have solar panels on your home?", "hasSolarPanels"],
            ["Do you currently have an outstanding solar panel loan?", "hasOutstandingSolarLoan"],
          ].map(([label, key]) => (
            <React.Fragment key={key}>
              <dt className="col-sm-9">{label}</dt>
              <dd className="col-sm-3">{answers[key] || "Not answered"}</dd>
            </React.Fragment>
          ))}
        </dl>
      </div>
    </section>
  );
}
